/* eslint-disable import/no-unresolved */
import { feathers } from '@/feathers-client';

const initialState = () => {
  return {
    error: null,
    isLoading: null,
    searchResults: [],
  };
};

export default {
  namespaced: true,
  state: initialState(),

  getters: {
    searchItems(state) {
      const { searchResults } = state;
      let searchItems = [];

      if (searchResults.length) {
        searchItems = [
          ...searchResults,
        ];
      } else {
        searchItems = [
          { header: 'No campaigns were found' },
        ];
      }
      return searchItems;
    },
  },

  mutations: {
    resetState(state) {
      Object.assign(state, initialState());
    },
    setStartCampaignError(state, payload) {
      state.error = payload;
    },
    setIsLoading(state, payload) {
      state.isLoading = payload;
    },
    setSearchResults(state, payload) {
      state.searchResults = payload;
    },
  },

  actions: {
    async resetState({ commit }) {
      commit('resetState');
    },
    async findCampaigns({ commit }, search = '') {
      const query = {
        $paginate: 'false',
      };

      if (search) {
        query.name = {
          $like: `%${search}%`,
        };
      }
      let response;
      try {
        commit('setIsLoading', true);
        response = await feathers.service('campaigns').find({ query });
        commit('setSearchResults', response.data);
      } catch (error) {
        commit('setStartCampaignError', error);
      }
      commit('setIsLoading', false);
    },
  },
};
